import classnames from "classnames";
import React, { Fragment } from "react";

import { ProductVisibilityTypes } from "@utils/enums";

import { ProductVariant } from "lib/@types/service/product/shared";

import "./swatches.scss";

type Props = {
    variantGroup: ProductVariant[];
    sku: string;
};

const Swatches = ({ variantGroup, sku }: Props) => {
    return (
        <Fragment>
            {variantGroup
                .filter(
                    variant =>
                        variant.productVisibilityType !==
                        ProductVisibilityTypes.NotAvailable,
                )
                .map(variant => (
                    <div
                        key={variant.sku}
                        className="d-flex flex-row flex-wrap"
                    >
                        <a
                            title={variant.productTitle}
                            href={variant.url}
                            className={classnames(
                                "swatches",
                                sku === variant.sku ? "swatches--active" : "",
                                "d-flex justify-content-center align-items-center m-1",
                            )}
                        >
                            {variant.productVisibilityType ===
                                ProductVisibilityTypes.TemporaryNotAvailable && (
                                <div className="swatches--stripes" />
                            )}
                            {variant.thumbnailUrl && (
                                <img
                                    src={variant.thumbnailUrl}
                                    alt={variant.productTitle}
                                />
                            )}
                        </a>
                    </div>
                ))}
        </Fragment>
    );
};

export default Swatches;
